<template>
  <div>
    <ItemPreview
      v-for="item in items"
      :key="item.id"
      class="mb-4"
      :item="item"
      @open-item="openItemId = $event"
    />
    <v-dialog
      v-model="dialog"
      :fullscreen="$vuetify.display.xs"
    >
      <v-card>
        <v-card-text>
          <ItemFull
            v-if="openedItem"
            :item="openedItem"
            @back="dialog = false"
          />
        </v-card-text>
      </v-card>
    </v-dialog>
  </div>
</template>

<script lang="ts" setup>
import { computed, ref, watch } from 'vue';
import { ParsedFeedItem } from '../../JsonFeed';
import ItemFull from './ItemFull.vue';
import ItemPreview from './ItemPreview.vue';

const props = defineProps<{
  items: ParsedFeedItem[],
}>();

// ******* mode = events (Feed / Лента событий)
// Лента событий это фактически записи блога.

// Лента выводится с сортировкой по дате по убыванию (новое вверху). По каждой записи:

// Левая колонка:
//   Картинка

// Правая колонка:

//   Дата публикации
//   Название
//   Краткий текст

//   Кнопка "Читать далее" (если есть ссылка на пост)


// Клик на запись открывает отдельный экранчик с полными содержанием поста блога:

// Одна колонка:
//   Дата публикации
//   Название
//   Картинка
//   Полный текст
//   Кнопка Share/Поделиться которая видна только если есть URL


const openItemId = ref<string | null>(null);
const dialog = ref(false);
const openedItem = computed(() => props.items.find(item => item.id === openItemId.value));

watch(openItemId, (newVal) => {
  dialog.value = newVal !== null;
});

watch(dialog, (newVal) => {
  if (!newVal) {
    openItemId.value = null;
  }
});
</script>
